import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ReactNode;
    isSelected: boolean;
    label: string;
    onSelect: () => void;
    propertyType?: boolean;
}

export const HomeMatchPreferencesSurveyCard = (props: IProps) => {
    const {icon, isSelected, label, onSelect, propertyType = false} = props;

    return (
        <button aria-pressed={isSelected} className={propertyType ? propertyTypeCardStyle : cardStyle} onClick={onSelect} type="button">
            {propertyType ? <span className={propertyTypeIconStyle}>{icon}</span> : <span className={floorIconStyle}>{icon}</span>}
            <Text as="span" preserveFontSize variant="body_copy_2">
                {label}
            </Text>
        </button>
    );
};

const cardStyle = css({
    alignItems: "center",
    background: "transparent",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    height: "12rem",
    justifyContent: "center",
    minWidth: 0,
    px: 0,
    py: 2,
    width: "100%",

    "&[aria-pressed='true']": {
        borderColor: "var(--colors-secondary)"
    }
});

const floorIconStyle = css({
    alignItems: "center",
    display: "flex",
    height: "6.4rem",
    justifyContent: "center",
    width: "6.4rem"
});

const propertyTypeCardStyle = css({
    alignItems: "center",
    background: "transparent",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    height: "12rem",
    justifyContent: "center",
    minWidth: 0,
    px: 0,
    py: 2,
    width: "100%",

    "&[aria-pressed='true']": {
        borderColor: "var(--colors-secondary)",
        borderWidth: "1.5px"
    }
});

const propertyTypeIconStyle = css({
    alignItems: "center",
    display: "flex",
    height: "6.4rem",
    justifyContent: "center",
    width: "6.4rem"
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ReactNode;
    isSelected: boolean;
    label: string;
    onSelect: () => void;
    propertyType?: boolean;
}

export const HomeMatchPreferencesSurveyCard = (props: IProps) => {
    const {icon, isSelected, label, onSelect, propertyType = false} = props;

    return (
        <button aria-pressed={isSelected} className={propertyType ? propertyTypeCardStyle : cardStyle} onClick={onSelect} type="button">
            {propertyType ? <span className={propertyTypeIconStyle}>{icon}</span> : <span className={floorIconStyle}>{icon}</span>}
            <Text as="span" preserveFontSize variant="body_copy_2">
                {label}
            </Text>
        </button>
    );
};

const cardStyle = css({
    alignItems: "center",
    background: "transparent",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    height: "12rem",
    justifyContent: "center",
    minWidth: 0,
    px: 0,
    py: 2,
    width: "100%",

    "&[aria-pressed='true']": {
        borderColor: "var(--colors-secondary)"
    }
});

const floorIconStyle = css({
    alignItems: "center",
    display: "flex",
    height: "6.4rem",
    justifyContent: "center",
    width: "6.4rem"
});

const propertyTypeCardStyle = css({
    alignItems: "center",
    background: "transparent",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: 1,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    height: "12rem",
    justifyContent: "center",
    minWidth: 0,
    px: 0,
    py: 2,
    width: "100%",

    "&[aria-pressed='true']": {
        borderColor: "var(--colors-secondary)",
        borderWidth: "1.5px"
    }
});

const propertyTypeIconStyle = css({
    alignItems: "center",
    display: "flex",
    height: "6.4rem",
    justifyContent: "center",
    width: "6.4rem"
});
